import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export default function Manifesto() {
    const { t } = useLanguage();
    const LINES = t("manifesto.lines");
    return (
        <section className="py-24 md:py-40 bg-zinc-100" data-testid="manifesto-section">
            <div className="px-5 md:px-10 max-w-4xl">
                <div>
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        className="text-xs tracking-[0.35em] uppercase text-zinc-500 mb-8"
                    >
                        {t("manifesto.eyebrow")}
                    </motion.p>
                    <motion.h2
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.4 }}
                        variants={{ visible: { transition: { staggerChildren: 0.12 } } }}
                        className="font-display font-bold uppercase tracking-tight text-3xl md:text-5xl leading-[1.05]"
                    >
                        {LINES.map((line, i) => (
                            <span key={i} className="block overflow-hidden">
                                <motion.span
                                    className="block"
                                    variants={{
                                        hidden: { y: "110%" },
                                        visible: { y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
                                    }}
                                >
                                    {line}
                                </motion.span>
                            </span>
                        ))}
                    </motion.h2>
                </div>
            </div>
        </section>
    );
}
